<template>
  <div style="min-width: 100px">
    <button
        id="btn-start-recording"
        @click="toggleRecorder"
        type="button"
        ref="audioBut"
        v-if="audioPlayerDisplay === 'none'"
    >{{ recordBtnText }}</button>
    <audio ref="audio" :style="{display: audioPlayerDisplay}"></audio>
  </div>
</template>

<script>
import RecordRTC from "recordrtc";

export default {
  name: "AudioRecord",
  data() {
    return {
      recordingStarted: false,
      fileExists: false,
      audioRecorder: null,
      intervalId: null,
    };
  },
  computed: {
    recordBtnText() {
      return this.recordingStarted ? this.$t('stop') : this.$t('record_audio')+" (1хв)";
    },
    audioPlayerDisplay() {
      return this.fileExists ? 'block' : 'none';
    },
  },
  methods: {
    toggleRecorder() {
      this.recordingStarted ? this.stopRec() : this.startRec();
    },
    startRec() {
      this.captureMedia(media => {
        this.audioRecorder = new RecordRTC(media, {
          type: 'audio'
        });

        this.audioRecorder.startRecording();
        this.recordingStarted = true;
        //this.fileExists = false;
        this.setRecTime(1);
      });
    },
    setRecTime(minuts) {
      let counter = 0;
      this.intervalId = setInterval((e) => {
        counter += 1;
        if (counter === (minuts*60)) {
            this.stopRec();
            clearInterval(this.intervalId);
          }
        }, 1000);
    },
    stopRec() {
      this.audioRecorder.stopRecording(() => {
        this.stopRecordingCallback();
        this.uploadMedia();
      });
      this.recordingStarted = false;
      this.fileExists = true;
      clearInterval(this.intervalId);
    },
    captureMedia(callback) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(media => {
          const mediaElement = this.$refs["audio"];
          mediaElement.srcObject = media;
          callback(media);
        })
        .catch(error => {
          alert('Unable to capture your media. Please check console logs.');
          console.error(error);
        });

        
    },
    stopRecordingCallback() {
      const mediaElement = this.$refs["audio"];
      mediaElement.srcObject = null;
      mediaElement.src = URL.createObjectURL(this.audioRecorder.getBlob());
    },
    uploadMedia() {
      const blob = this.audioRecorder.getBlob();
      this.$emit('audio-captured', blob);
    },
  }
};
</script>

<style scoped>

</style>
